import { render, staticRenderFns } from "./bookinfo.html?vue&type=template&id=aa1f4324&scoped=true&"
import script from "./bookinfo.js?vue&type=script&lang=js&"
export * from "./bookinfo.js?vue&type=script&lang=js&"
import style0 from "./bookinfo.sass?vue&type=style&index=0&id=aa1f4324&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1f4324",
  null
  
)

component.options.__file = "bookinfo.vue"
export default component.exports